import { SET_USER_DATA } from './loginTypes';

export const setUserData = ({ user_id, userData, token }) => {
  return (dispatch) => {
    dispatch({ type: SET_USER_DATA, payload: { user_id, userData, token } });
  };
};
